
import Vue from 'vue'

export default Vue.extend({
   name: 'ExpandingPanel',
   props: {
      title: { type: String, default: 'Panel ' },
   },
   data() {
      return {
         expanded: false,
      }
   },
   methods: {
      toggleExpand() {
         this.expanded = !this.expanded
      },
   },
})
